module.exports = __webpack_public_path__ + "static/img/bootstrap-logo-uni-of-salamanca.f74bdb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootstrap-logo-uni-of-salamanca.png
// module id = UK0J
// module chunks = 1